import { userConstants } from './../constants/user.constants';

const initialState = {};

export function Readytodisburse(state = initialState, action) {
  switch (action.type) {
    case userConstants.READYTODISBURSE_REQUEST:
      return {
        user: action.user,
        isLoading : true

      };
    case userConstants.READYTODISBURSE_SUCCESS:
      const {res} = action
        
      return {
        res,
        isLoading : false
      };
    case userConstants.READYTODISBURSE_FAILURE:
      return {
        isLoading : false
      };
    default:
      return state
  }
}